import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MoreInfo from 'components/more-info/container';

export default class ButtonTile extends Component {

  /* Render */

  render() {
    const { disabled, onClick, selected } = this.props;

    const className = classnames(
      'button-tile',
      {
        'button-tile--selected': selected,
      },
    );

    return (
      <button
        className={className}
        disabled={disabled}
        onClick={onClick}
        type="button"
      >
        {this.renderChildren()}
      </button>
    );
  }

  renderInfo() {
    const { info } = this.props;
    return info && (<div className="button-tile__info"><MoreInfo content={info} /></div>);
  }

  renderChildren() {
    const { children, icon, iconSize, text, svg } = this.props;
    let content = null;

    if (children) {
      content = (
        <div className="button-tile__content button-tile__content--with-spacing">
          {this.renderInfo()}
          {children}
        </div>
      );
    } else {
      let image = null;
      if (icon) image = (<span className={`icon ${icon} ${iconSize}`} />);
      if (svg) image = (<img src={svg} alt={text} className="button-tile__svg" />);

      content = (
        <div className="button-tile__content">
          {this.renderInfo()}
          {image}
          <div className="button-tile__text">
            {text}
          </div>
        </div>
      );
    }

    return content;
  }
}

ButtonTile.defaultProps = {
  disabled: false,
  iconSize: 'icon--xxl',
  selected: false,
};

ButtonTile.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  svg: PropTypes.string,
  info: PropTypes.element,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};



// WEBPACK FOOTER //
// ./js/components/button-tile/index.jsx